module.exports = "<header class=\"modal-header\">\n    <h2 class=\"modal-title\">{{title}}</h2>\n    <div class=\"portlet-options\">\n        <span class=\"close\" data-dismiss=\"modal\">&times;</span>\n    </div>\n</header>\n\n<div class=\"modal-body\">\n\n</div>\n\n<footer class=\"modal-footer\">\n    <button class=\"btn btn-primary\" data-dismiss=\"modal\" data-i18n=\"common.buttons.close\">Schließen</button>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/settingsTemplate.tpl.html
// module id = 935
// module chunks = 12